import LeaseField from './LeaseField.component';

export default LeaseField;
